import toast from 'react-hot-toast';
import {Toast} from "@/app/_components";

export default class BigTips {

    static showMsg(message: string) {
        // todo 展示先屏蔽
        // toast(message);
        Toast.show(message);
        console.log('BigTips',message)
    }

    static success(message: string, options = {}) {
        toast.success(message, options);
    }

    static error(message: string, options = {}) {
        toast.error(message, options);
    }

    static loading(message: string, options = {}) {
        toast.loading(message, options);
    }

    static custom(message: string, options = {}) {
        toast(message, options);
    }

    static dismiss(id: string) {
        toast.dismiss(id);
    }

    static removeAll() {
        toast.dismiss();
    }
}

// window.bigTips = BigTips;


